export default {
    timeout: 10 * 1000,
    host: 'https://xhyz.207c522.com/', // 线上
    // host: 'http://xhyapi.qzappapia456.com/', // uat
    webKey: 'luckygogointch-intech',
    endPoint: 'H5'
  }
  